import { t } from 'localization/utils/t';

const TP = 'search.enums.constants';

export const GRID_SCROLL_POSITION = 'GOAT.grid_scroll_position';

export const GRID_CELL_DATA_QA = 'grid_cell_product';

export const RESULTS_PER_PAGE = 24;

export const SORT = 'sort';

export const SORT_FILTER_BUTTON_CLASSNAME = 'filter-sort-button';

export const CATEGORY_LABEL_MAP = {
  Sneakers: {
    value: t(`${TP}.sneakers`, 'All Sneakers'),
    TK: 'sneakers',
    TP,
  },
  Apparel: {
    value: t(`${TP}.apparel`, 'All Apparel'),
    TK: 'apparel',
    TP,
  },
  Space: {
    value: t(`${TP}.space`, 'All Space'),
    TK: 'space',
    TP,
  },
  Collectibles: {
    value: t(`${TP}.collectibles`, 'All Collectibles'),
    TK: 'collectibles',
    TP,
  },
  Art: {
    value: t(`${TP}.art`, 'All Art'),
    TK: 'art',
    TP,
  },
};

export const SIZE_SORT = [
  'xxxs',
  'xxxs/xxs',
  'xxs',
  'xxs/xs',
  'xs',
  'xs/s',
  's',
  's/m',
  'm',
  'm/l',
  'l',
  'l/xl',
  'xl',
  'xl/xxl',
  'xxl',
  'xxl/xxxl',
  'xxxl',
  '4xl',
];

export const SIZE_GENDER = {
  men: {
    value: t(`${TP}.men`, 'US Men'),
    TK: 'men',
    TP,
  },
  women: {
    value: t(`${TP}.women`, 'US Women'),
    TK: 'women',
    TP,
  },
};

export const GENDER_SORT = ['men', 'women', 'youth', 'infant'];
export const SIZE_TITLE_SORT = ['shoes', 'tops', 'bottoms', 'outerwear', 'dresses', 'belts'];
export const CONDITION_TITLE_SORT = ['new', 'used', 'new_with_defects', 'goat_clean'];
export const FILTER_ENUMS = {
  AVAILABLE_NOW: 'is_in_stock',
  BRAND: 'brand',
  CATEGORY: 'web_groups',
  COLOR: 'color',
  CONDITION: 'product_condition',
  DISCOUNT_TAG: 'discount_tag',
  GENDER: 'gender',
  INSTANT_SHIP: 'instant_ship_lowest_price_cents',
  PRICE: 'lowest_price_cents',
  PRICE_BUCKET: 'lowest_price_cents_bucket',
  RELEASE_DATE: 'release_date',
  RECENTLY_RELEASED: 'recently_released',
  SIZE: 'size_converted',
  YEAR: 'release_date_year',
  YEAR_BUCKET: 'release_date_year_bucket',
};

export const CONSTRUCTOR_SERVICE_URL = 'https://ac.cnstrc.com';

export const SHOWED_COUNTRY_TOASTER = 'GOAT.showed_country_toaster';

export const PRODUCT_CATEGORIES = [
  'shoes',
  'clothing',
  'accessories',
  'bags',
  'virtual',
  'space',
  'collectibles',
  'art',
  'jewelry',
  'apparel',
  'wallets',
  'hats',
  'eyewear',
  'swimwear',
  'dressses',
  'bottoms',
  'outerwear',
  't_shirts',
  'tops',
  'sneakers',
];

export const GIFT_CARDS_SUGGESTED_SEARCH = {
  id: 'gift-cards',
  title: 'Gift Cards',
  searchConfig: {
    collectionId: 'gift-cards',
  },
};

export const GIFT_CARDS_SEARCH_TERMS = ['gift card', 'gift cards', 'giftcard', 'giftcards'];
